document.addEventListener('DOMContentLoaded', () => {
    // 1. Find all tab buttons matching Bootstrap's data attribute
    const tabButtons = document.querySelectorAll('[data-bs-toggle="tab"]');

    tabButtons.forEach(button => {
        console.log("got a button")

        button.addEventListener('click', (e) => {
            e.preventDefault();

            console.log("got a click")

            // 2. Identify the current component context container to isolate this tab set
            const context = button.closest('.search') || document;

            // 3. Resolve the target content pane selector
            const targetSelector = button.getAttribute('data-bs-target');
            const targetPane = context.querySelector(targetSelector);

            console.log("targets", targetPane, targetSelector)

            if (!targetPane) return;

            // 4. Deactivate and hide siblings (Updating ARIA attributes dynamically)
            const navContainer = button.closest('.nav-tabs');
            if (navContainer) {
                navContainer.querySelectorAll('[data-bs-toggle="tab"]').forEach(link => {
                    link.parentElement.classList.remove('active');
                    // Set accessibility status to unselected
                    link.setAttribute('aria-selected', 'false');
                });
            }

            const contentContainer = targetPane.closest('.tab-content');
            if (contentContainer) {
                contentContainer.querySelectorAll('.tab-pane').forEach(pane => {
                    pane.classList.remove('active', 'show');
                    // Optional: Explicitly tell assistive tools this content pane is hidden
                    pane.setAttribute('aria-hidden', 'true');
                });
            }

            // 5. Activate and show the clicked elements (Updating ARIA to selected)
            button.parentElement.classList.add('active');
            button.setAttribute('aria-selected', 'true');

            targetPane.classList.add('active');
            targetPane.removeAttribute('aria-hidden'); // Make visible to screen readers

            // Tiny delay handles triggering the native CSS fade animation smoothly
            setTimeout(() => targetPane.classList.add('show'), 20);
        });
    });
});
